import { SWReactIcons } from "@similarweb/icons";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import styled from "styled-components";

export const StyledSWReactIcon = styled(SWReactIcons)`
    align-self: center;
`;

export const StyledCell = styled(FlexRow)`
    column-gap: 12px;
`;
